"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dark = exports.light = void 0;
exports.light = {
    mode: "light",
};
exports.dark = {
    mode: "dark",
};
//# sourceMappingURL=palette.js.map